<template>
  <footer class="bg-slate-900 text-slate-300 py-12 mt-16">
    <div class="container mx-auto px-4">
      <div class="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
        <div class="text-center md:text-left">
          <!-- Logo in footer -->
          <div class="flex justify-center md:justify-start mb-4">
            <router-link to="/" class="transition-transform duration-200 hover:scale-105">
              <img src="@/assets/images/logo-dark.svg" alt="Hardware Pulse" class="h-6 w-auto opacity-80 hover:opacity-100 transition-opacity duration-200" />
            </router-link>
          </div>
          <p class="text-sm">&copy; 2025 Hardware Pulse. All rights reserved.</p>
          <p class="text-xs text-slate-400 mt-1">Your trusted source for hardware reviews and tech insights.</p>
        </div>
        <ul class="flex space-x-6 text-sm">
          <li>
            <router-link to="/privacy-policy" class="text-slate-300 hover:text-cyan-400 transition-colors duration-200 hover:underline">
              Privacy Policy
            </router-link>
          </li>
          <li>
            <router-link to="/terms-and-conditions" class="text-slate-300 hover:text-cyan-400 transition-colors duration-200 hover:underline">
              Terms of Service
            </router-link>
          </li>
        </ul>
      </div>

      <!-- Tech-themed decorative element -->
      <div class="mt-8 pt-8 border-t border-slate-700 text-center">
        <div class="flex justify-center items-center space-x-2 text-slate-500">
          <div class="w-2 h-2 bg-cyan-500 rounded-full animate-pulse"></div>
          <span class="text-xs font-mono">POWERED BY INNOVATION</span>
          <div class="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'Footer',
  };
</script>

<style scoped>
  /* Tailwind CSS handles all styling */
</style>
